export enum ItemStyleAccess {
    Group = 'GROUP',
    Private = 'PRIVATE',
    Public = 'PUBLIC',
}
